import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import App from "./App.vue";
import Main from "./components/Main.vue";
import Leadership from "./components/Leadership.vue";
import Analysis from "./components/Analysis.vue";
import Brief from "./components/Brief.vue";
import Inquire from "./components/Inquire.vue";


const routes = [
  { path : "/", component: Main },
  { path : "/leadership", component: Leadership },
  { path : "/analysis", component: Analysis },
  { path : "/brief", component: Brief },
  { path : "/inquire", component: Inquire },
]

Vue.config.productionTip = false

new Vue({
  router: new VueRouter({routes}),
  render: h => h(App),
}).$mount('#app')

